import { render, staticRenderFns } from "./DeviceInfoPerformaceDescongelar.vue?vue&type=template&id=25f2c265&"
import script from "./DeviceInfoPerformaceDescongelar.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPerformaceDescongelar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports